(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-amount"] && !Shopify.designMode) return;
  try {
    
  function initializeGiftAmounts() {
    document.querySelectorAll('[data-gift-amount]').forEach((root) => {
      if (root.dataset.initialized) return;
      const form = root.querySelector('form');
      const input = root.querySelector('[data-gift-input]');
      const variantInput = root.querySelector('[data-gift-variant]');
      const submit = root.querySelector('[data-gift-submit]');
      const price = root.querySelector('[data-gift-price]');
      const error = root.querySelector('[data-gift-error]');
      const fields = root.querySelector('[data-gift-fields]');
      const presets = root.querySelectorAll('[data-gift-preset]');
      let variants;
      try { variants = JSON.parse(root.querySelector('[data-gift-variants]').textContent); } catch { return; }
      const money = new Intl.NumberFormat(root.dataset.locale || 'nl', {style: 'currency', currency: root.dataset.currency || 'EUR'});
      const sync = () => {
        const amount = input.valueAsNumber;
        const variant = variants[String(amount * 100)];
        const valid = input.validity.valid && Number.isInteger(amount) && amount >= 1 && amount <= 250 && variant && variant.available;
        variantInput.value = valid ? variant.id : '';
        submit.disabled = !valid;
        error.textContent = valid ? '' : root.dataset.error;
        input.setAttribute('aria-invalid', String(!valid));
        price.textContent = valid ? money.format(variant.price / 100) : '—';
        presets.forEach((button) => button.setAttribute('aria-pressed', String(valid && Number(button.dataset.giftPreset) === amount)));
        return Boolean(valid);
      };
      presets.forEach((button) => button.addEventListener('click', () => { input.value = button.dataset.giftPreset; sync(); }));
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      form.addEventListener('submit', (event) => { if (!sync()) { event.preventDefault(); input.focus(); } });
      fields.disabled = false;
      root.dataset.initialized = 'true';
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeGiftAmounts); else initializeGiftAmounts();
  document.addEventListener('shopify:section:load', initializeGiftAmounts);
  document.addEventListener('shopify:section:reorder', initializeGiftAmounts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
